import { MenuTreeDetail, PreferencesApi as PreferencesApiInternal } from '@portal/pkg-api/gen/admin'
import { RestApiConfiguration } from '@portal/pkg-api/config'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { data } from '@portal/pkg-api/shared'

export const PreferencesApi = new PreferencesApiInternal(RestApiConfiguration)

const prefix = 'admin.preferences'

export const PreferenceQueries = {
  menuTree: () => ({
    queryKey: [`${prefix}.menuTree`],
    queryFn: () => data(PreferencesApi.getMenuTreeBasic({ mercatusNotifyOnError: false })),
  }),
  menuTreeDetail: () => ({
    queryKey: [`${prefix}.menuTreeDetail`],
    queryFn: () => data(PreferencesApi.getMenuTreeDetail()),
  }),
  rolesForMenus: () => ({
    queryKey: [`${prefix}.rolesForMenus`],
    queryFn: () => data(PreferencesApi.getRolesForMenus()),
  }),
}

export function useMenuTreeBasic() {
  return useQuery(PreferenceQueries.menuTree())
}

export function useSaveMenuTreeDetail() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (menuTreeDetail: Array<MenuTreeDetail>) =>
      data(PreferencesApi.saveMenuTreeDetail(menuTreeDetail)),
    onSuccess: () => {
      void queryClient.invalidateQueries(PreferenceQueries.menuTree())
      void queryClient.invalidateQueries(PreferenceQueries.menuTreeDetail())
    },
  })
}
